import { useState } from "react";
import { Star } from "lucide-react";

export const StarRow = ({ n = 5, size = "w-4 h-4" }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className={`${size} ${i < Math.round(n) ? "fill-[#F6B21B] text-[#F6B21B]" : "fill-gray-200 text-gray-200"}`} />
    ))}
  </div>
);

export const StarPicker = ({ value = 0, onChange, size = "w-9 h-9" }) => {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex gap-1" data-testid="star-picker">
      {[1, 2, 3, 4, 5].map((i) => (
        <button key={i} type="button" onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(0)}
          onClick={() => onChange(i)} data-testid={`star-${i}`} aria-label={`${i} star`}
          className="transition-transform hover:scale-110">
          <Star className={`${size} ${i <= (hover || value) ? "fill-[#F6B21B] text-[#F6B21B]" : "fill-gray-200 text-gray-200"}`} />
        </button>
      ))}
    </div>
  );
};
